(function () {
  "use strict";

  var NARROW_MQ = "(max-width: 989px)";
  var PAGE_SIZE_DESKTOP = 12;
  var PAGE_SIZE_NARROW = 6;

  function getPageSize() {
    return window.matchMedia(NARROW_MQ).matches ? PAGE_SIZE_NARROW : PAGE_SIZE_DESKTOP;
  }

  function cacheProductNodes(el) {
    if (el._kgProductNodes && el._kgProductNodes.length) return;
    el._kgProductNodes = Array.prototype.slice.call(
      el.querySelectorAll(".kg-bestsellers__grid-item")
    );
  }

  function prepareSwiperEl(el) {
    cacheProductNodes(el);
    var items = el._kgProductNodes;
    var wrapper = el.querySelector(".swiper-wrapper");
    if (!wrapper || !items.length) return;

    var pageSize = getPageSize();

    if (el.swiper) {
      el.swiper.destroy(false, false);
    }

    while (wrapper.firstChild) {
      wrapper.removeChild(wrapper.firstChild);
    }

    for (var i = 0; i < items.length; i += pageSize) {
      var slide = document.createElement("div");
      slide.className = "swiper-slide";
      var grid = document.createElement("div");
      grid.className = "kg-bestsellers__grid";
      for (var j = i; j < Math.min(i + pageSize, items.length); j++) {
        grid.appendChild(items[j]);
      }
      slide.appendChild(grid);
      wrapper.appendChild(slide);
    }
  }

  function prepareSectionSwipers(section) {
    section.querySelectorAll("[data-bestsellers-swiper]").forEach(prepareSwiperEl);
  }

  function destroyPanelSwiper(panel) {
    var el = panel.querySelector("[data-bestsellers-swiper]");
    if (el && el.swiper) {
      el.swiper.destroy(false, false);
    }
  }

  function initBestsellersSwiper(section, panel) {
    var el = panel.querySelector("[data-bestsellers-swiper]");
    if (!el) return null;

    prepareSwiperEl(el);

    if (typeof Swiper === "undefined") return null;

    if (el.swiper) {
      el.swiper.destroy(false, false);
    }

    var prev = section.querySelector(".kg-bestsellers__nav-btn--prev");
    var next = section.querySelector(".kg-bestsellers__nav-btn--next");

    return new Swiper(el, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      roundLengths: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: prev,
        nextEl: next
      }
    });
  }

  function initVisibleSwiper(section) {
    var visible = section.querySelector(".collection-block:not(.hidden)");
    if (visible) {
      initBestsellersSwiper(section, visible);
    }
  }

  function relayoutSection(section) {
    prepareSectionSwipers(section);
    initVisibleSwiper(section);
  }

  function bindSection(section) {
    if (section.dataset.kgBestsellersBound === "true") return;
    section.dataset.kgBestsellersBound = "true";

    var tabs = section.querySelectorAll(".collection-tab-item");
    var panels = section.querySelectorAll(".collection-block");

    function showPanel(handle) {
      panels.forEach(function (panel) {
        var isMatch = panel.id === "collection-" + handle;
        if (!isMatch) {
          destroyPanelSwiper(panel);
        }
        panel.classList.toggle("hidden", !isMatch);
        if (isMatch) {
          initBestsellersSwiper(section, panel);
        }
      });
    }

    tabs.forEach(function (tab) {
      function activate() {
        tabs.forEach(function (t) {
          t.classList.remove("active");
          t.setAttribute("aria-selected", "false");
        });
        tab.classList.add("active");
        tab.setAttribute("aria-selected", "true");
        showPanel(tab.dataset.handle);
      }

      tab.addEventListener("click", activate);
      tab.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          activate();
        }
      });
    });

    var tabContainer = section.querySelector(".collection-tab");
    if (tabContainer) {
      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;

      tabContainer.addEventListener("mousedown", function (e) {
        isDown = true;
        tabContainer.classList.add("dragging");
        startX = e.pageX - tabContainer.offsetLeft;
        scrollLeft = tabContainer.scrollLeft;
      });
      tabContainer.addEventListener("mouseleave", function () {
        isDown = false;
        tabContainer.classList.remove("dragging");
      });
      tabContainer.addEventListener("mouseup", function () {
        isDown = false;
        tabContainer.classList.remove("dragging");
      });
      tabContainer.addEventListener("mousemove", function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - tabContainer.offsetLeft;
        tabContainer.scrollLeft = scrollLeft - (x - startX) * 2;
      });
    }

    var mq = window.matchMedia(NARROW_MQ);
    var onMqChange = function () {
      relayoutSection(section);
    };
    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", onMqChange);
    } else if (typeof mq.addListener === "function") {
      mq.addListener(onMqChange);
    }

    prepareSectionSwipers(section);
    initVisibleSwiper(section);
  }

  function boot() {
    document.querySelectorAll("[data-kg-bestsellers]").forEach(bindSection);
  }

  function initAllSwipers() {
    document.querySelectorAll("[data-kg-bestsellers]").forEach(function (section) {
      prepareSectionSwipers(section);
      initVisibleSwiper(section);
    });
  }

  function bootWhenReady() {
    boot();
    if (typeof Swiper === "undefined") {
      window.addEventListener("load", initAllSwipers, { once: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootWhenReady);
  } else {
    bootWhenReady();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector("[data-kg-bestsellers]");
    if (section) {
      bindSection(section);
    }
  });
})();
